<template>
  <div class="page-content">
    <div class="bg__wrapper">
      <div class="bg-content text-center">
        <p class="text--size-giant text-bold text-white">Sorry</p>

        <h1 class="text-bold text-white">This page is currently down for maintenance</h1>
      </div>
    </div>

    <v-container class="app-container--width-max info-block">
      <div class="content content--padding">
        <h3 class="text-bold text-black my-7">We'll be back very soon</h3>

        <p class="text-black mb-8">
          We are currently completing some maintenance work on the website, but don't worry, we will
          be back online shortly.
        </p>

        <p class="text-black mb-8">Sorry for any inconvenience this may cause.</p>

        <p class="text-black mb-8">
          If you would like any help you can use our online

          <span class="text-link text-bold" @click="showChat">Chat</span>
          service or call our Customer Services team on 0345 601 1050.
        </p>

        <p class="text-black mb-8">Monday - Friday 8.15am - 5.45pm, Saturday 9am - 2pm</p>
      </div>
    </v-container>
  </div>
</template>

<script>
import { HOME_PAGE_URL } from '@/constants/page.constants';
import { FAQS_LINK } from '@/constants/external-link.constants';
import { mdiOpenInNew } from '@mdi/js';

export default {
  data() {
    return {
      FAQS_LINK,
      mdiOpenInNew,
    };
  },
  methods: {
    backToHome() {
      this.$router.push(HOME_PAGE_URL);
    },
    showChat() {
      window.Helpshift('open');
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: ($grid-breakpoints-md - 1)) {
  .page-content {
    height: 100%;
    min-height: 700px;

    .bg {
      &__wrapper {
        background-image: url(~@/assets/images/404.jpg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        height: 50vh;
        width: 100%;
        position: relative;
      }

      &-content {
        @include center-element;
      }
    }

    .info-block {
      height: 50%;
      text-align: center;
    }
  }
}

@media only screen and (min-width: ($grid-breakpoints-md - 1)) {
  .page-content {
    height: 100%;
    min-height: 700px;

    .bg {
      &__wrapper {
        background-image: url(~@/assets/images/404.jpg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        height: 30vh;
        width: 100%;
        position: relative;
      }

      &-content {
        @include center-element;
      }
    }

    .info-block {
      height: 50%;
      text-align: center;
    }
  }
}

@media screen and (max-width: ($grid-breakpoints-md - 1)) {
  .page-content {
    min-height: 100vh;
  }
}
</style>
